import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { leavesService } from '../../../../api/services/leavesService';
import {
  setAllLeaveHistory,
  setRefreshLeaveHistory,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';

interface PropsValues {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEmpLeaveHistoryData: (data: any) => void;
  yearFilter: number;
  typeFilter: string;
}

function DTOLeaveHistory({
  setEmpLeaveHistoryData,
  yearFilter,
  typeFilter,
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);

  const leaveHistory = useAppSelector(
    (state) => state.leaveHistorySlice.leaveHistory,
  );
  const dispatch = useAppDispatch();
  async function getEmpLeaveHistory(companyId: number, empId: number) {
    dispatch(setRefreshLeaveHistory(true));
    const response = await leavesService.getEmployeeLeaveHistory(
      companyId,
      empId,
    );
    if (response) {
      dispatch(setAllLeaveHistory(response.data));
      setEmpLeaveHistoryData(response.data);
      dispatch(setRefreshLeaveHistory(false));
    } else {
      dispatch(setRefreshLeaveHistory(false));
    }
  }

  async function getEmpLeaveHistoryWithYear(
    companyID: number,
    empId: number,
    year: number,
    type: string,
  ) {
    dispatch(setRefreshLeaveHistory(true));
    const response = await leavesService.getEmployeeLeaveHistoryWithYear(
      companyID,
      empId,
      year,
      type,
    );
    if (response?.response === 'success') {
      dispatch(setRefreshLeaveHistory(false));
      dispatch(setAllLeaveHistory(response.data));
      setEmpLeaveHistoryData(response.data);
    } else {
      dispatch(setRefreshLeaveHistory(false));
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getEmpLeaveHistory(selector.company_id, selector.emp_id);
  }, []);

  useEffect(() => {
    if (yearFilter != 0 || typeFilter != '') {
      getEmpLeaveHistoryWithYear(
        selector.company_id,
        selector.emp_id,
        yearFilter,
        typeFilter,
      );
    }
  }, [yearFilter, typeFilter]);

  useEffect(() => {
    setEmpLeaveHistoryData(leaveHistory);
  }, [leaveHistory]);

  return <></>;
}
export default DTOLeaveHistory;
